import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';

import LanguageMenu from './language-menu.jsx';
import MenuBarMenu from './menu-bar-menu.jsx';
import ThemeMenu from './theme-menu.jsx';
import {MenuItem, MenuSection, Submenu} from '../menu/menu.jsx';

import menuBarStyles from './menu-bar.css';
import styles from './settings-menu.css';

import settingsIconNew from './settings-icon.png';
import usbDriverIcon from './downloads.png';
import servoLiveIcon from './icon--servo-live.png';

const SettingsMenu = ({
    canChangeLanguage,
    canChangeTheme,
    isRtl,
    locale,
    onRequestClose,
    onRequestOpen,
    settingsMenuOpen,
    servoLiveEnabled,
    onToggleServoLive
}) => {
    const [usbDriverMenuOpen, setUsbDriverMenuOpen] = React.useState(false);
    const currentModule = new URLSearchParams(window.location.search).get('module') || '';
    const isXlineModule = currentModule === 'xline';
    const isKorean = locale === 'ko';

    const toggleUsbDriverMenu = () => {
        setUsbDriverMenuOpen(!usbDriverMenuOpen);
    };

    const downloadDriver = fileName => {
        window.open(`/static/drivers/${fileName}`, '_blank', 'noopener,noreferrer');
    };

    const downloadWindowsDriver = () => downloadDriver('CH341SER.zip');
    const downloadMacDriver = () => downloadDriver('CH341SER_MAC.ZIP');

    return (
        <React.Fragment>
            <div
                className={classNames(
                    menuBarStyles.menuBarItem,
                    menuBarStyles.themeMenu,
                    {
                        [menuBarStyles.active]: settingsMenuOpen
                    }
                )}
            >
                <div
                    className={classNames(
                        menuBarStyles.hoverable,
                        styles.trigger
                    )}
                    onClick={onRequestOpen}
                >
                    <img
                        src={settingsIconNew}
                        style={{width: '1.2rem', height: '1.2rem'}}
                    />
                    <span className={styles.dropdownLabel}>
                        <FormattedMessage
                            defaultMessage="Settings"
                            description="Settings menu"
                            id="gui.menuBar.settings"
                        />
                    </span>
                    {/* <img src={dropdownCaret} /> */}
                </div>
                <MenuBarMenu
                    className={menuBarStyles.menuBarMenu}
                    open={settingsMenuOpen}
                    place={isRtl ? 'right' : 'left'}
                    onRequestClose={onRequestClose}
                >
                    <MenuSection>
                        {canChangeLanguage && <LanguageMenu onRequestCloseSettings={onRequestClose} />}
                        {canChangeTheme && <ThemeMenu onRequestCloseSettings={onRequestClose} />}
                        {!isXlineModule && (
                            <MenuItem onClick={onToggleServoLive}>
                                <div className={styles.option}>
                                    <img
                                        className={classNames(styles.icon, styles.servoLiveIcon, {
                                            [styles.servoLiveIconOff]: !servoLiveEnabled
                                        })}
                                        src={servoLiveIcon}
                                    />
                                    <span className={styles.submenuLabel}>
                                        {servoLiveEnabled ?
                                            (locale === 'ko' ? '라이브 서보: ON' : 'Live Servo: ON') :
                                            (locale === 'ko' ? '라이브 서보: OFF' : 'Live Servo: OFF')}
                                    </span>
                                </div>
                            </MenuItem>
                        )}
                        <MenuItem expanded={usbDriverMenuOpen}>
                            <div
                                className={styles.option}
                                // eslint-disable-next-line react/jsx-no-bind
                                onClick={toggleUsbDriverMenu}
                            >
                                <img
                                    className={styles.icon}
                                    src={usbDriverIcon}
                                    style={{width: '1.3rem', height: '1.3rem'}}
                                />
                                <span className={styles.submenuLabel}>{isKorean ? 'USB 드라이버' : 'USB Driver'}</span>
                            </div>
                            <Submenu place={isRtl ? 'right' : 'left'}>
                                <MenuItem
                                    // eslint-disable-next-line react/jsx-no-bind
                                    onClick={downloadWindowsDriver}
                                >
                                    {isKorean ? 'Windows용' : 'For Windows'}
                                </MenuItem>
                                <MenuItem
                                    // eslint-disable-next-line react/jsx-no-bind
                                    onClick={downloadMacDriver}
                                >
                                    {isKorean ? 'Mac용' : 'For macOS'}
                                </MenuItem>
                            </Submenu>
                        </MenuItem>
                    </MenuSection>
                </MenuBarMenu>
            </div>
        </React.Fragment>
    );
};

SettingsMenu.propTypes = {
    canChangeLanguage: PropTypes.bool,
    canChangeTheme: PropTypes.bool,
    isRtl: PropTypes.bool,
    locale: PropTypes.string,
    onRequestClose: PropTypes.func,
    onRequestOpen: PropTypes.func,
    settingsMenuOpen: PropTypes.bool,
    servoLiveEnabled: PropTypes.bool,
    onToggleServoLive: PropTypes.func
};

export default SettingsMenu;
